import actHttp from '@/utils/actHttp'

export default {
  // 登录
  login: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/login', params)
  },
  // 获取公共配置
  getCommonConfig: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/get-common-config', params)
  },
  // 获取用户抽奖详情
  getUserDetail: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/get-user-detail', params)
  },
  // 获取抽奖列表
  getLotteryDisplayList: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/get-lottery-display-list', params)
  },
  // 抽奖
  lottery: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/lottery', params)
  },
  // 一键抽检
  lotteryAll: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/lottery-all', params)
  },
  // 获取累抽奖励列表
  getAccumulateRewardList: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/get-accumulate-reward-list', params)
  },
  // 获取抽奖记录
  getLotteryRecord: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/get-lottery-record', params)
  },
  // 领取累抽奖励
  receiveAccumulateReward: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/receive-accumulate-reward', params)
  },
  // 一键领取累抽奖励
  receiveAccumulateRewardAll: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/receive-accumulate-reward-all', params)
  },
  // 获取累抽奖励记录
  getAccumulateRewardRecord: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/get-accumulate-reward-record', params)
  },
  // 领取登录奖励
  receiveFreeReward: (params) => {
    return actHttp.post('/minifire-doubleegg/api/v1/receive-free-reward', params)
  },
}

